<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('scoreAssessment.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('scoreAssessment.pageTitle'),
            href: '/score-assessments'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-loading-banner :loading="loading">
        <ts-card-wrapper>
          <div class="row mb-3">
            <div class="col-md-6">
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('scoreAssessment.condition') }}</legend>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row mb-2">
                        <label class="required col-md-4 col-form-label">{{
                          $t('scoreAssessment.programStructure')
                        }}</label>
                        <div class="col-md-8">
                          <a-select
                            v-model.number="condition.program_structure_id"
                            :options="program_structure_list"
                            :showSearch="true"
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            @change="handleFetchComponent"
                          ></a-select>
                        </div>
                      </div>
                      <div class="row mb-2">
                        <label class="col-md-4 col-form-label"></label>
                        <div class="col-md-8 ts-whitespace-no-wrap">
                          <div class="ts-inline-block mr-2">
                            <ts-checkbox
                              v-model="condition.enable_semester"
                              @change="enableSemesterChange"
                              >{{
                                $t('scoreAssessment.enableSemester')
                              }}</ts-checkbox
                            >
                          </div>
                          <div class="ts-inline-block mr-2">
                            <ts-checkbox
                              v-model="condition.enable_sciense"
                              @change="enableScienceChange"
                              >{{
                                $t('scoreAssessment.enableScience')
                              }}</ts-checkbox
                            >
                          </div>
                          <div class="ts-inline-block">
                            <ts-checkbox
                              v-model="condition.is_percentage"
                              @change="isPercentageChange"
                              >{{
                                $t('scoreAssessment.enablePercentage')
                              }}</ts-checkbox
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
            <div class="col-md-6">
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('scoreAssessment.customeDivider') }}</legend>
                  <custome-divider
                    :params="{
                      sc_setup_id: parseInt(id),
                      program_structure_id: condition.program_structure_id
                    }"
                  />
                </fieldset>
              </form>
            </div>
          </div>
        </ts-card-wrapper>
        <div class="row">
          <div class="col-md-12">
            <panel
              :title="$t('scoreAssessment.component')"
              style="margin-bottom:0;"
            >
              <component-table-list
                v-model="model"
                :component-list="components"
                :params="{
                  sc_setup_id: parseInt(id),
                  program_structure_id: condition.program_structure_id
                }"
              />
              <div class="row">
                <div class="col-md-8 d-flex align-items-center">
                  <p class="text-danger" v-if="show_alert">
                    <i class="fas fa-exclamation-triangle"></i>
                    <span
                      >The system cann't save above component. Please check it
                      and try to click button save again.</span
                    >
                  </p>
                </div>
                <div class="col-md-4 text-right ts-whitespace-no-wrap">
                  <ts-button
                    class="mr-2"
                    @click.prevent="$router.push({ name: 'score-assessment' })"
                    >{{ $t('cancel') }}</ts-button
                  >
                  <ts-button
                    outline
                    color="primary"
                    class="mr-2"
                    :waiting="waiting_new"
                    @click.prevent="onSaveAddNew"
                    >{{ $t('save_add_new') }}</ts-button
                  >
                  <ts-button
                    color="primary"
                    :waiting="waiting"
                    @click.prevent="onSave"
                    >{{ $t('save') }}</ts-button
                  >
                </div>
              </div>
            </panel>
          </div>
        </div>
      </ts-loading-banner>
    </ts-card>
  </div>
</template>

<script>
import CustomeDivider from './components/score-assessment-custome-divider'
import ComponentTableList from './components/component-table-list'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'scoreAssessmentCreate',
  components: {
    CustomeDivider,
    ComponentTableList
  },
  props: {
    id: {
      Type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      show_alert: false,
      condition: {
        program_structure_id: null,
        enable_semester: false,
        enable_sciense: false,
        is_percentage: false
      },
      model: [],
      program_structure_list: [],
      components: []
    }
  },
  created() {
    if (parseInt(this.$route.query.program_structure_id)) {
      this.condition.program_structure_id = this.$route.query.program_structure_id
      this.handleFetchComponent(this.condition.program_structure_id)
    }
    this.fetchProgramStructure()
  },
  methods: {
    ...mapActions('scoreAssessment', [
      'getProgramStructure',
      'getComponent',
      'storeDetailComponent',
      'findDetailComponent'
    ]),
    fetchProgramStructure() {
      this.loading = true
      this.getProgramStructure(this.id)
        .then(response => {
          this.program_structure_list = response.data.map(el => ({
            value: el.program_structure_id,
            label: el.structure_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // fetch componet base on assessment setup to create sub component
    fetchComponent(program_structure_id) {
      this.loading = true
      this.getComponent({
        sc_setup_id: this.id,
        program_structure_id: program_structure_id
      })
        .then(response => {
          this.components = _.orderBy(response.data, ['display_order'])
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // fetch sub-component/component detail if already exist
    fetchComponentDetail(program_structure_id) {
      this.loading = true
      this.findDetailComponent({
        sc_setup_id: this.id,
        program_structure_id: program_structure_id
      })
        .then(response => {
          this.setDataToModelifExist(response.data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleFetchComponent(program_structure_id) {
      if (this.$route.query.program_structure_id != program_structure_id) {
        this.$router.replace({
          params: { id: this.id },
          query: { program_structure_id: program_structure_id }
        })
      }
      this.fetchComponent(program_structure_id),
        this.fetchComponentDetail(program_structure_id)
    },
    enableSemesterChange() {
      this.model.forEach(el => {
        el.enable_semester = this.condition.enable_semester
        el.actual_score_semester = 0
        el.actual_score_sciense_semester = 0
        el.score_component_detail_item_list.forEach(sub => {
          sub.enable_semester = this.condition.enable_semester
          sub.actual_score_semester = 0
          sub.actual_score_sciense_semester = 0
        })
      })
    },
    enableScienceChange() {
      this.model.forEach(el => {
        el.enable_sciense = this.condition.enable_sciense
        el.actual_score_sciense = 0
        el.actual_score_sciense_semester = 0
        el.score_component_detail_item_list.forEach(sub => {
          sub.enable_sciense = this.condition.enable_sciense
          sub.actual_score_sciense = 0
          sub.actual_score_sciense_sciense = 0
          sub.actual_score_sciense_semester = 0
        })
      })
    },
    isPercentageChange() {
      this.model.forEach(el => {
        el.is_percentage = this.condition.is_percentage
        el.percentage = 0
        el.score_component_detail_item_list.forEach(sub => {
          sub.is_percentage = this.condition.is_percentage
          sub.percentage = 0
        })
      })
    },
    onSave() {
      this.waiting = true
      this.show_alert = false
      Promise.all(
        this.model.map((el, index) => {
          return this.storeDetailComponent(el)
            .then(response => {
              this.model.splice(index, 1)
            })
            .catch(error => {
              if (this.model.length > 0) {
                this.show_alert = true
              }
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        })
      ).finally(() => {
        if (!this.show_alert) {
          this.$router.push({ name: 'score-assessment' })
        }
        this.waiting = false
      })
    },
    onSaveAddNew() {
      this.waiting_new = true
      this.show_alert = false
      Promise.all(
        this.model.map((el, index) => {
          return this.storeDetailComponent(el)
            .then(response => {
              this.model.splice(index, 1)
            })
            .catch(error => {
              if (this.model.length > 0) {
                this.show_alert = true
              }
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        })
      ).finally(() => {
        if (!this.show_alert) {
          this.clearInput()
          this.show_alert = false
        }
        this.waiting_new = false
      })
    },
    setDataToModelifExist(data) {
      this.model = []
      if (data.length > 0) {
        this.condition.program_structure_id = data[0].program_structure_id
        this.condition.enable_semester = data[0].enable_semester
        this.condition.enable_sciense = data[0].enable_sciense
        this.condition.is_percentage = data[0].is_percentage
        data.forEach(el => {
          this.model.push({
            sc_setup_detail_id: el.sc_setup_detail_id,
            sc_setup_id: el.sc_setup_id,
            program_structure_id: el.program_structure_id,
            sc_subject_id: el.sc_subject_id,
            actual_score: el.actual_score,
            enable_semester: el.enable_semester,
            actual_score_semester: el.actual_score_semester,
            enable_sciense: el.enable_sciense,
            actual_score_sciense: el.actual_score_sciense,
            actual_score_sciense_semester: el.actual_score_sciense_semester,
            sc_ass_cat_id: el.sc_ass_cat_id,
            remarks: el.remarks,
            is_percentage: el.is_percentage,
            percentage: el.percentage,
            sc_multiplier: el.sc_multiplier,
            enable_semester_scoring_threshold_option:
              el.enable_semester_scoring_threshold_option,
            semester_scoring_threshold: el.semester_scoring_threshold,
            score_component_detail_item_list: el.component_detail_item_list.map(
              el => ({
                sc_setup_detail_item_id: el.sc_setup_detail_item_id,
                sc_item_subject_id: el.sc_item_subject_comp_id,
                actual_score: el.actual_score,
                enable_semester: el.enable_semester,
                actual_score_semester: el.actual_score_semester,
                enable_sciense: el.enable_sciense,
                actual_score_sciense: el.actual_score_sciense,
                actual_score_sciense_semester: el.actual_score_sciense_semester,
                remarks: el.remarks,
                is_percentage: el.is_percentage,
                percentage: el.percentage
              })
            )
          })
        })
      } else {
        this.condition.enable_semester = false
        this.condition.enable_sciense = false
        this.condition.is_percentage = false
      }
    },
    clearInput() {
      this.model = []
      ;(this.condition.program_structure_id = null),
        (this.condition.enable_semester = false),
        (this.condition.enable_sciense = false),
        (this.condition.is_percentage = false)
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('scoreAssessment/RESET_STATE')
    next()
  }
}
</script>
